'use client'

/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/function-component-definition */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useState } from 'react'
import { ACKODRIVE_DOMAIN, CAR_SEARCH } from '@components/Ackodrive/common/constants'
import assetLoader from '@utils/internalImageLoader'
import Image from 'next/image'
import PropertyControlledComponent from '@components/PropertyControlledComponent/PropertyControlledComponent'
import CallbackPopup from './CallbackPopup'
import CallbackWidgetForm from './CallbackWidgetForm'
import SuccessMessageContainer from './SuccessMessageContainer'
import CallbackDesktopWidget from './CallbackDesktopWidget'
import ErrorMessageContainer from './ErrorMessageContainer'
import {
  CallBackWidgetContainer,
  CallBackWidgetContainerMobile,
  CallBackWidgetDesktopContainer,
  CallBackWidgetDesktopContainerPurple,
  CallBackWidgetDesktopContainerPurpleMobile,
  MobileOverlay,
  WidgetMobileFloater,
} from './styles'
import DynamicWidget from '../ackoDriveWidget'
import { ackoDriveWidgetType } from '../ackoDriveWidgetConfig'

const widgetStates = {
  INITIAL_STATE: 'INITIAL_STATE',
  DISPLAY_FORM: 'DISPLAY_FORM',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
}

interface CallbackWidgetProps {
  isMobile: boolean
  blogAdWidget?: any
  regexPatternsData: any
}

const CallbackWidget = ({ regexPatternsData, isMobile, blogAdWidget = {} }: CallbackWidgetProps) => {
  const [widgetState, setWidgetState] = useState(widgetStates.INITIAL_STATE)
  const [onWidgetFloaterClick, setOnWidgetFloaterClick] = useState(false)

  const widgetType = blogAdWidget?.attributes?.widget
  const widgetTypeAckoDrive = ackoDriveWidgetType(widgetType)
  const closeForm = () => {
    setWidgetState(widgetStates.INITIAL_STATE)
  }

  if (isMobile) {
    switch (widgetState) {
      case widgetStates.INITIAL_STATE:
        return (
          <>
            <PropertyControlledComponent fallback={null} controllerProperty={widgetTypeAckoDrive}>
                  <CallBackWidgetContainerMobile>
                    <WidgetMobileFloater onClick={() => setOnWidgetFloaterClick(true)}>
                      <span>
                        <Image src={CAR_SEARCH} width={42} height={42} alt="carIcon" />
                      </span>
                      Fetch vehicle information
                      <Image src={`${assetLoader()}/images/arrow-right.svg`} alt="icon" width="20" height="20" />
                    </WidgetMobileFloater>
                  </CallBackWidgetContainerMobile>
                  <PropertyControlledComponent fallback={null} controllerProperty={onWidgetFloaterClick}>
                    <>
                      <MobileOverlay />
                      <CallBackWidgetDesktopContainerPurpleMobile>
                        <DynamicWidget
                          widgetType={widgetTypeAckoDrive}
                          blogAdWidget={blogAdWidget}
                          regexPatternsData={regexPatternsData}
                          setOnWidgetFloaterClick={setOnWidgetFloaterClick}
                        />
                      </CallBackWidgetDesktopContainerPurpleMobile>
                    </>
                  </PropertyControlledComponent>
            </PropertyControlledComponent>
          </>
        )
      case widgetStates.DISPLAY_FORM:
        return <CallbackPopup closePopup={closeForm} />
      case widgetStates.SUCCESS:
        return <SuccessMessageContainer isMobile={isMobile} handleClose={closeForm} />
      case widgetStates.ERROR:
        return <ErrorMessageContainer isMobile={isMobile} handleClose={closeForm} />
      default:
        return null
    }
  } else {
    const getComponentForState = () => {
      switch (widgetState) {
        case widgetStates.INITIAL_STATE:
          return (
            <CallbackDesktopWidget
              onClickHandler={() => {
                if (typeof window !== 'undefined') {
                  window.location.href = `${ACKODRIVE_DOMAIN}cars/`
                }
              }}
            />
          )
        case widgetStates.DISPLAY_FORM:
          return <CallbackWidgetForm />
        case widgetStates.SUCCESS:
          return <SuccessMessageContainer isMobile={isMobile} handleClose={closeForm} />
        case widgetStates.ERROR:
          return <ErrorMessageContainer isMobile={isMobile} handleClose={closeForm} />
        default:
          return null
      }
    }
    return (
      <CallBackWidgetContainer>
            <PropertyControlledComponent fallback={null} controllerProperty={widgetTypeAckoDrive}>
              <CallBackWidgetDesktopContainerPurple>
                <DynamicWidget
                  widgetType={widgetTypeAckoDrive}
                  blogAdWidget={blogAdWidget}
                  regexPatternsData={regexPatternsData}
                  setOnWidgetFloaterClick={setOnWidgetFloaterClick}
                />
              </CallBackWidgetDesktopContainerPurple>
            </PropertyControlledComponent>
        <CallBackWidgetDesktopContainer id="callbackWidgetDesktop">
          {getComponentForState()}
        </CallBackWidgetDesktopContainer>
      </CallBackWidgetContainer>
    )
  }
}

export default CallbackWidget
